"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { OfficeSuggestion } from "../_types/wizard-types";

const OfficeSuggestionsContext = createContext<OfficeSuggestion[]>([]);

interface OfficeSuggestionsProviderProps {
  /** The enterprise's offices, loaded server-side by `getOfficeSuggestions`. */
  offices: OfficeSuggestion[];
  children: ReactNode;
}

/**
 * Makes the enterprise's office suggestions available to the location step, which sits several
 * components below the page that loads them.
 *
 * @param props - The offices and the wizard subtree that reads them.
 * @returns The provider element.
 */
export function OfficeSuggestionsProvider({ offices, children }: OfficeSuggestionsProviderProps) {
  return <OfficeSuggestionsContext.Provider value={offices}>{children}</OfficeSuggestionsContext.Provider>;
}

/**
 * Reads the enterprise's office suggestions for the current wizard.
 *
 * @returns The offices, or an empty array outside a provider or when the enterprise has none.
 */
export function useOfficeSuggestions(): OfficeSuggestion[] {
  return useContext(OfficeSuggestionsContext);
}
